export enum TicketsEstatus {
    ABIERTA = 1,
    PROCESO =2,
    ATENDIDA = 3,
    VOBO = 4,
    CANCELADA = 5,
    REABIERTA = 6,
}
